import { useQuery } from '@tanstack/react-query';
import { fetchConfigs } from '../api/data-qa-api';
import { ConfigSummary } from '../data-qa-types';

// `suppressGlobalError`: the page reports a load failure itself through useSetError.
export const useMmmDataQaConfigs = (cid: string | undefined) =>
  useQuery<ConfigSummary[]>({
    queryKey: ['mmmDataQAConfigs', cid],
    queryFn: () => fetchConfigs(cid!),
    enabled: Boolean(cid),
    meta: { suppressGlobalError: true }
  });
